import React from "react";
import { useIntl } from "@ai360/core/intl";

import { toSelectableCropDropdownOptions, useCropList } from "~/utils/crops/use-crop-list";
import { useLoggedInUserProductScopeOrgLevelGuid } from "~/utils/products/use-product-list";

import AddEditPanelContainer from "./../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { pickLists, unitTypes, dropdowns, service, model } from "./../data";

const ConnectedAddEditPanel = AddEditPanelContainer(AddEditPanel, {
    pickLists,
    unitTypes,
    dropdowns,
    service,
});

const AddEditContainer = (props) => {
    const { formatMessage } = useIntl();
    const orgLevelGuid = useLoggedInUserProductScopeOrgLevelGuid();
    const { crops } = useCropList({ orgLevelGuid });

    return (
        <ConnectedAddEditPanel
            {...props}
            {...{ [model.PROPS_CROP_NAME]: toSelectableCropDropdownOptions(crops, formatMessage) }}
        />
    );
};

export default AddEditContainer;
